<!--
    Compact card of ONE Antragseingang (uiMode == 'inline').
    Row 1: icon + Antragstyp + "#id" + status badge · Row 2: Kunde/Lead · Row 3: Einreichdatum.
-->
@if (!initialized) {
    <p-skeleton height="5rem" styleClass="border-round-xl"></p-skeleton>
} @else if (dto) {
    <div (click)="handleClick()"
         class="cw-request-inline flex flex-column justify-content-between p-3 border-round-xl surface-ground cursor-pointer">

        <!-- Row 1: Icon + Antragstyp + #id + status badge -->
        <div class="flex align-items-center justify-content-between gap-2 mb-2">
            <div class="flex align-items-center gap-2 overflow-hidden">
                <i class="fa-regular fa-inbox text-blue-700 bg-blue-100 border-round-lg p-2 cw-request-inline-icon"></i>
                <span class="text-sm font-bold text-900 white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {{ requestTypeName }}
                </span>
                <span class="text-sm font-normal text-600 flex-shrink-0">#{{ dto.id }}</span>
            </div>
            @if (statusLabel) {
                <p-tag [value]="statusLabel"
                       [icon]="statusIcon"
                       [severity]="statusSeverity"
                       styleClass="text-xs">
                </p-tag>
            }
        </div>

        <!-- Row 2+3: Kunde und Einreichdatum -->
        <div class="flex flex-column gap-1">
            @if (customerName) {
                <div class="flex align-items-center gap-1 text-xs font-medium text-700 white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    <i class="fa-regular fa-user text-xs"></i>
                    <span pTooltip="Kunde" tooltipPosition="bottom">{{ customerName }}</span>
                </div>
            }
            <div class="flex align-items-center gap-1 text-xs text-500">
                <i class="fa-regular fa-calendar text-xs"></i>
                <!-- [CD-10 / B-09] submittedAt ist ein ZEITSTEMPEL, also tt.mm.jjjj hh:mm — wortgleich
                     mit dem Kontextkopf desselben Antragseingangs (cw-request-context-header). Die
                     reine Datumsangabe hier ließ denselben Zeitpunkt in zwei Schreibweisen erscheinen,
                     je nachdem, ob der Antrag als Karte oder als Seite geöffnet war. -->
                <span pTooltip="Eingereicht am" tooltipPosition="bottom">
                    {{ dto.submittedAt ? (dto.submittedAt | date: 'dd.MM.yyyy HH:mm') : 'Noch nicht eingereicht' }}
                </span>
            </div>
        </div>

    </div>
} @else {
    <div class="flex align-items-center gap-2 p-3 border-round-xl surface-ground text-xs text-color-secondary">
        <i class="fa-regular fa-triangle-exclamation text-orange-500"></i>
        <span>Der Beraterantrag konnte nicht geladen werden.</span>
    </div>
}
